// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ReservationReportDetails_report__D8tP6 {
  width: 100%;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  color: #13231D;
}
.ReservationReportDetails_report__header__KvL5y {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 24px;
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__header__KvL5y {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin-bottom: 20px;
  }
}
.ReservationReportDetails_report__eyebrow__OKv7j {
  display: block;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #82B194;
  margin-bottom: 8px;
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__eyebrow__OKv7j {
    font-size: 10px;
  }
}
.ReservationReportDetails_report__title__luB5Z {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.03em;
  margin: 0;
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__title__luB5Z {
    font-size: 24px;
  }
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__actions__euBuE {
    display: flex;
    width: 100%;
  }
  .ReservationReportDetails_report__actions__euBuE > * {
    flex: 1 1;
  }
}
.ReservationReportDetails_report__card__BHROT {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__card__BHROT {
    padding: 24px 20px;
  }
}
@media (max-width: 480px) {
  .ReservationReportDetails_report__card__BHROT {
    padding: 20px 16px;
  }
}
.ReservationReportDetails_report__grid__uOucy {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
@media (max-width: 1024px) {
  .ReservationReportDetails_report__grid__uOucy {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
}
@media (max-width: 600px) {
  .ReservationReportDetails_report__grid__uOucy {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
.ReservationReportDetails_report__item__x4RHL {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ReservationReportDetails_report__item--full__fq3wa {
  grid-column: 1/-1;
}
.ReservationReportDetails_report__label__8\\+B4q {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6B8277;
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__label__8\\+B4q {
    font-size: 11px;
  }
}
.ReservationReportDetails_report__value__BPkdI {
  font-size: 16px;
  font-weight: 600;
  color: #13231D;
  margin: 0;
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__value__BPkdI {
    font-size: 15px;
  }
}
.ReservationReportDetails_report__date-wrapper__lTZtK {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ReservationReportDetails_report__link__WuzeP {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 800;
  color: #e67e22;
  text-decoration: none;
  background: rgba(230, 126, 34, 0.08);
  padding: 4px 10px;
  border-radius: 8px;
  width: fit-content;
  transition: all 0.2s ease;
}
.ReservationReportDetails_report__link__WuzeP:hover {
  background: rgba(230, 126, 34, 0.15);
  transform: translateY(-1px);
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__link__WuzeP {
    font-size: 11px;
  }
}
.ReservationReportDetails_report__divider__mMVJN {
  height: 1px;
  background-color: rgba(16, 25, 21, 0.06);
  border: none;
  margin: 32px 0;
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__divider__mMVJN {
    margin: 24px 0;
  }
}
.ReservationReportDetails_report__section__Yv2xf {
  margin-bottom: 24px;
}
.ReservationReportDetails_report__section__Yv2xf:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__section__Yv2xf {
    margin-bottom: 20px;
  }
}
.ReservationReportDetails_report__observations-box__MnZgI, .ReservationReportDetails_report__notes-box__hHGlJ {
  margin-top: 12px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 16px;
  font-size: 15px;
  line-height: 1.6;
  color: rgba(19, 35, 29, 0.68);
}
.ReservationReportDetails_report__observations-box__MnZgI p, .ReservationReportDetails_report__notes-box__hHGlJ p {
  margin: 0;
}
@media (max-width: 768px) {
  .ReservationReportDetails_report__observations-box__MnZgI, .ReservationReportDetails_report__notes-box__hHGlJ {
    padding: 16px;
    font-size: 14px;
    border-radius: 12px;
  }
}
.ReservationReportDetails_report__notes-box__hHGlJ {
  background: #F8F6F2;
  border-style: dashed;
}

@media print {
  .ReservationReportDetails_report__D8tP6 {
    padding: 0;
    print-color-adjust: exact;
  }
  .ReservationReportDetails_report__header__KvL5y {
    margin-bottom: 20px;
  }
  .ReservationReportDetails_report__actions__euBuE {
    display: none;
  }
  .ReservationReportDetails_report__card__BHROT {
    box-shadow: none;
    border: 1px solid #eee;
    background: #fff;
    padding: 20px;
  }
  .ReservationReportDetails_report__observations-box__MnZgI, .ReservationReportDetails_report__notes-box__hHGlJ {
    border: 1px solid #eee;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/ReservationReportDetails/ReservationReportDetails.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AALA;EACI,WAAA;EACA,oFDPQ;ECQR,cDUmB;ACFvB;AANI;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAQR;AANQ;EANJ;IAOQ,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;EASV;AACF;AANI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDzBe;EC0Bf,kBAAA;AAQR;AANQ;EATJ;IAUQ,eAAA;EASV;AACF;AANI;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AAQR;AANQ;EANJ;IAOQ,eAAA;EASV;AACF;AALQ;EADJ;IAEQ,aAAA;IACA,WAAA;EAQV;EANU;IACI,SAAA;EAQd;AACF;AAJI;EACI,mBDhDe;ECiDf,wCAAA;EACA,mBDnBQ;ECoBR,aAAA;EACA,2CDLM;ACWd;AAJQ;EAPJ;IAQQ,kBAAA;EAOV;AACF;AALQ;EAXJ;IAYQ,kBAAA;EAQV;AACF;AALI;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AAOR;AALQ;EALJ;IAMQ,8BAAA;IACA,SAAA;EAQV;AACF;AANQ;EAVJ;IAWQ,0BAAA;IACA,SAAA;EASV;AACF;AANI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAQR;AANQ;EACI,iBAAA;AAQZ;AAJI;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAMR;AAJQ;EAPJ;IAQQ,eAAA;EAOV;AACF;AAJI;EACI,eAAA;EACA,gBAAA;EACA,cDnGe;ECoGf,SAAA;AAMR;AAJQ;EANJ;IAOQ,eAAA;EAOV;AACF;AAJI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAMR;AAHI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAKR;AAHQ;EACI,oCAAA;EACA,2BAAA;AAKZ;AAFQ;EAnBJ;IAoBQ,eAAA;EAKV;AACF;AAFI;EACI,WAAA;EACA,wCAAA;EACA,YAAA;EACA,cAAA;AAIR;AAFQ;EANJ;IAOQ,cAAA;EAKV;AACF;AAFI;EACI,mBAAA;AAIR;AAHQ;EAAe,gBAAA;AAMvB;AAJQ;EAJJ;IAKQ,mBAAA;EAOV;AACF;AAJI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BDnKe;ACyKvB;AAJQ;EAAI,SAAA;AAOZ;AALQ;EAZJ;IAaQ,aAAA;IACA,eAAA;IACA,mBAAA;EAQV;AACF;AALI;EACI,mBDrLe;ECsLf,oBAAA;AAOR;;AAHA;EACI;IACI,UAAA;IAEA,yBAAA;EAMN;EALM;IAAY,mBAAA;EAQlB;EAPM;IAAa,aAAA;EAUnB;EATM;IACI,gBAAA;IACA,sBAAA;IACA,gBAAA;IACA,aAAA;EAWV;EATM;IACI,sBAAA;EAWV;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-primary: $color-primary;\n$bw-text: $text-main;\n$bw-muted: $text-secondary;\n$bw-border: $color-border;\n$bw-surface: $color-surface;\n$bw-surface-soft: $color-surface-soft;\n$bw-radius-xl: $radius-xl;\n$bw-shadow: $shadow-card;\n\n.report {\n    width: 100%;\n    font-family: $font-main;\n    color: $bw-text;\n\n    &__header {\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        margin-bottom: 24px;\n\n        @media (max-width: 768px) {\n            flex-direction: column;\n            align-items: stretch;\n            gap: 16px;\n            margin-bottom: 20px;\n        }\n    }\n\n    &__eyebrow {\n        display: block;\n        font-size: 11px;\n        font-weight: 800;\n        text-transform: uppercase;\n        letter-spacing: 0.14em;\n        color: $bw-primary;\n        margin-bottom: 8px;\n\n        @media (max-width: 768px) {\n            font-size: 10px;\n        }\n    }\n\n    &__title {\n        font-size: 32px;\n        font-weight: 800;\n        letter-spacing: -0.03em;\n        margin: 0;\n\n        @media (max-width: 768px) {\n            font-size: 24px;\n        }\n    }\n\n    &__actions {\n        @media (max-width: 768px) {\n            display: flex;\n            width: 100%;\n            \n            & > * {\n                flex: 1;\n            }\n        }\n    }\n\n    &__card {\n        background: $bw-surface;\n        border: 1px solid $bw-border;\n        border-radius: $bw-radius-xl;\n        padding: 40px;\n        box-shadow: $bw-shadow;\n\n        @media (max-width: 768px) {\n            padding: 24px 20px;\n        }\n\n        @media (max-width: 480px) {\n            padding: 20px 16px;\n        }\n    }\n\n    &__grid {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 24px;\n\n        @media (max-width: 1024px) {\n            grid-template-columns: 1fr 1fr;\n            gap: 20px;\n        }\n\n        @media (max-width: 600px) {\n            grid-template-columns: 1fr;\n            gap: 16px;\n        }\n    }\n\n    &__item {\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n\n        &--full {\n            grid-column: 1 / -1;\n        }\n    }\n\n    &__label {\n        font-size: 12px;\n        font-weight: 800;\n        text-transform: uppercase;\n        letter-spacing: 0.08em;\n        color: #6B8277; \n\n        @media (max-width: 768px) {\n            font-size: 11px;\n        }\n    }\n\n    &__value {\n        font-size: 16px;\n        font-weight: 600;\n        color: $bw-text;\n        margin: 0;\n\n        @media (max-width: 768px) {\n            font-size: 15px;\n        }\n    }\n\n    &__date-wrapper {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    &__link {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 12px;\n        font-weight: 800;\n        color: #e67e22; \n        text-decoration: none;\n        background: rgba(230, 126, 34, 0.08);\n        padding: 4px 10px;\n        border-radius: 8px;\n        width: fit-content;\n        transition: all 0.2s ease;\n\n        &:hover {\n            background: rgba(230, 126, 34, 0.15);\n            transform: translateY(-1px);\n        }\n\n        @media (max-width: 768px) {\n            font-size: 11px;\n        }\n    }\n\n    &__divider {\n        height: 1px;\n        background-color: rgba(16, 25, 21, 0.06);\n        border: none;\n        margin: 32px 0;\n\n        @media (max-width: 768px) {\n            margin: 24px 0;\n        }\n    }\n\n    &__section {\n        margin-bottom: 24px;\n        &:last-child { margin-bottom: 0; }\n\n        @media (max-width: 768px) {\n            margin-bottom: 20px;\n        }\n    }\n\n    &__observations-box, &__notes-box {\n        margin-top: 12px;\n        padding: 20px;\n        background: #ffffff;\n        border: 1px solid $bw-border;\n        border-radius: 16px;\n        font-size: 15px;\n        line-height: 1.6;\n        color: $bw-muted;\n        \n        p { margin: 0; }\n\n        @media (max-width: 768px) {\n            padding: 16px;\n            font-size: 14px;\n            border-radius: 12px;\n        }\n    }\n\n    &__notes-box {\n        background: $bw-surface-soft;\n        border-style: dashed;\n    }\n}\n\n@media print {\n    .report {\n        padding: 0;\n        -webkit-print-color-adjust: exact;\n        print-color-adjust: exact;\n        &__header { margin-bottom: 20px; }\n        &__actions { display: none; }\n        &__card {\n            box-shadow: none;\n            border: 1px solid #eee;\n            background: #fff;\n            padding: 20px;\n        }\n        &__observations-box, &__notes-box {\n            border: 1px solid #eee;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"report": `ReservationReportDetails_report__D8tP6`,
	"report__header": `ReservationReportDetails_report__header__KvL5y`,
	"report__eyebrow": `ReservationReportDetails_report__eyebrow__OKv7j`,
	"report__title": `ReservationReportDetails_report__title__luB5Z`,
	"report__actions": `ReservationReportDetails_report__actions__euBuE`,
	"report__card": `ReservationReportDetails_report__card__BHROT`,
	"report__grid": `ReservationReportDetails_report__grid__uOucy`,
	"report__item": `ReservationReportDetails_report__item__x4RHL`,
	"report__item--full": `ReservationReportDetails_report__item--full__fq3wa`,
	"report__label": `ReservationReportDetails_report__label__8+B4q`,
	"report__value": `ReservationReportDetails_report__value__BPkdI`,
	"report__date-wrapper": `ReservationReportDetails_report__date-wrapper__lTZtK`,
	"report__link": `ReservationReportDetails_report__link__WuzeP`,
	"report__divider": `ReservationReportDetails_report__divider__mMVJN`,
	"report__section": `ReservationReportDetails_report__section__Yv2xf`,
	"report__observations-box": `ReservationReportDetails_report__observations-box__MnZgI`,
	"report__notes-box": `ReservationReportDetails_report__notes-box__hHGlJ`
};
export default ___CSS_LOADER_EXPORT___;
